// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8FpPe","question":"styles_question__2kzTv","description":"styles_description__3YfeV"};